import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//

export default {
  name: 'discount-tag',
  props: {
    projectExtendVO: {
      type: Object,
      value: {}
    },
    performanceLabelVO: {
      type: Object,
      value: {}
    },
    promotionVO: {
      type: Object,
      value: null
    }
  },
  computed: {
    singleTicketId: function singleTicketId() {
      return this.projectExtendVO.maxDiscSingleTicketId && this.hasSaleLabel;
    },
    setTicketId: function setTicketId() {
      return this.projectExtendVO.maxDiscSetTicketId && this.hasSaleLabel;
    },
    assembleTicketId: function assembleTicketId() {
      return this.projectExtendVO.maxDiscAssembleTicketId && this.hasSaleLabel;
    },
    assembleValue: function assembleValue() {
      return this.projectExtendVO.maxDiscAssembleValue;
    },
    setValue: function setValue() {
      return this.projectExtendVO.maxDiscSetValue;
    },
    singleValue: function singleValue() {
      return this.projectExtendVO.maxDiscSingleValue;
    },
    hasSaleLabel: function hasSaleLabel() {
      return [2, 3].includes(this.performanceLabelVO.saleLabel);
    },
    discountText: function discountText() {
      var _this$promotionVO, _this$promotionVO$pro;
      // 从几个折扣中展示折扣力度最大的展示
      var promotionObj = ((_this$promotionVO = this.promotionVO) === null || _this$promotionVO === void 0 ? void 0 : (_this$promotionVO$pro = _this$promotionVO.promotionTags) === null || _this$promotionVO$pro === void 0 ? void 0 : _this$promotionVO$pro[0]) || {};
      if (promotionObj.tag) {
        if (promotionObj.type == 1) {
          return '早鸟票';
        }
        return promotionObj.tag;
      }
      var assembleValue = this.assembleTicketId ? Number(this.assembleValue) : 10;
      var singleValue = this.singleTicketId ? Number(this.singleValue) : 10;
      var setValue = this.setTicketId ? Number(this.setValue) : 10;
      var min = Math.min(assembleValue, singleValue, setValue);
      return min === 10 ? false : "".concat(min, "\u6298\u8D77");
    }
  }
};